export default __webpack_public_path__ + "static/media/img-b-end-bg.92889ebc.jpg";